<div [hidden]="menuVisivel">
  <button
    mat-raised-button
    onclick="window.scrollTo({top: 0, left: 0, behavior: 'smooth'})">
    Voltar ao topo
    <mat-icon class="icon-acoes">expand_less</mat-icon>
  </button>
</div>
